import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EstadoDocumentoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerEstadoDocumento(callback) {
        const inputParams = {
            entidad: {
                tipo_dte_codigo: 2
            }
        };
        this.gqlclient.query({
            query: gql `
        query ($entidad: estado_documentoInputType) {
          estado_documento {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_documento.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
EstadoDocumentoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EstadoDocumentoService_Factory() { return new EstadoDocumentoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EstadoDocumentoService, providedIn: "root" });
